<h1>Rewards/Snacks</h1>
<nav mat-tab-nav-bar [tabPanel]="tabPanel">
  @for (tab of tabs; track tab) {
    <a mat-tab-link (click)="gotoTab(tab)" [active]="tab.link === activeTab.link">
      {{tab.title}}
    </a>
  }
</nav>
@if (activeTab.id === 'rewards') {
  <app-superadmin-rewards-list></app-superadmin-rewards-list>
}
@if (activeTab.id === 'rebates') {
  <app-superadmin-rewards-rebates></app-superadmin-rewards-rebates>
}
@if (activeTab.id === 'brands') {
  <app-superadmin-rewards-brands></app-superadmin-rewards-brands>
}
@if (activeTab.id === 'campaigns') {
  <app-superadmin-rewards-campaigns></app-superadmin-rewards-campaigns>
}
@if (activeTab.id === 'claimed') {
  <app-superadmin-rewards-claimed></app-superadmin-rewards-claimed>
}
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
